/**
 * Thrown by the token getter when it aborts an in-flight request to start an
 * Auth0 re-auth redirect. The page is navigating away, so the React Query error
 * handler skips this — otherwise a spurious "request failed" toast flashes just
 * before the redirect.
 */
export class ReauthInProgressError extends Error {
  constructor(options?: { cause?: unknown }) {
    super("Re-authentication in progress", options);
    this.name = "ReauthInProgressError";
  }
}

export function isReauthInProgress(error: unknown): boolean {
  return error instanceof ReauthInProgressError;
}
